import React from 'react';
import cn from 'classnames';
import { Map } from 'immutable';
import { ID } from '@repo/utils/types';
import { ChevronDownIcon } from '@repo/icons';
import { itemListToString } from '@repo/utils/helpers/string';
import {
  labelsForPermissionsByResourceType,
  supportedPermissionsByResourceType,
  SharedResourceType,
} from '@repo/redux/reducers/data/shareStatuses';
import styles from './ResourcePermissionsTrigger.module.scss';

type PermissionsMap<PermissionType> = Map<PermissionType, ID | null | true>;

export function ResourcePermissionsTrigger<P extends string>({
  isOpen,
  triggerProps,
}: {
  isOpen: boolean;
  triggerProps: { sharedResourceType: SharedResourceType; permissions: PermissionsMap<P> };
}) {
  const supportedPermissions = supportedPermissionsByResourceType[
    triggerProps.sharedResourceType
  ] as P[];
  const labelForPermission = labelsForPermissionsByResourceType[
    triggerProps.sharedResourceType
  ] as { [permission in P]: string };
  const maxPermissionsCount = supportedPermissions.length;
  const enabledPermissions = supportedPermissions.filter((permission) =>
    triggerProps.permissions?.has(permission),
  );
  const enabledPermissionsCount = enabledPermissions.length || 0;
  let label = 'Public Info only';

  if (enabledPermissionsCount > 0 && enabledPermissionsCount < maxPermissionsCount) {
    label = itemListToString(
      enabledPermissions.map((permission) => labelForPermission[permission]),
    );
  } else if (enabledPermissionsCount == maxPermissionsCount) {
    label = 'Full profile';
  }

  return (
    <span className={cn(styles.editorTriggerButton, isOpen && styles.editorMenuOpen)}>
      {label}
      <ChevronDownIcon color="textSecondary" className={styles.triggerIcon} />
    </span>
  );
}
